import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvitationCommunicationService {
  public applicationGuid: string | null = null;
  public role: 'borrower' | 'supplier' | 'unknown' = 'unknown';

  // Subject to send the submit signal
  private submitApplicationSubject = new Subject<void>();

  // Observable that the parent component can subscribe to
  public submitApplication$ = this.submitApplicationSubject.asObservable();

  /**
   * Sends a signal to execute submitApplication in the AcceptInvitationComponent
   */
  public triggerSubmitApplication(): void {
    this.submitApplicationSubject.next();
  }
}
